__turbopack_context__.v({
  "assistant_message": "S7_QPq_assistant_message",
  "assistant_subtitle": "S7_QPq_assistant_subtitle",
  "assistant_title": "S7_QPq_assistant_title",
  "blockquote": "S7_QPq_blockquote",
  "card": "S7_QPq_card",
  "chat_content": "S7_QPq_chat_content",
  "chat_input_container": "S7_QPq_chat_input_container",
  "close_row": "S7_QPq_close_row",
  "code_block": "S7_QPq_code_block",
  "empty_state": "S7_QPq_empty_state",
  "error": "S7_QPq_error",
  "floating_button": "S7_QPq_floating_button",
  "input": "S7_QPq_input",
  "link": "S7_QPq_link",
  "message": "S7_QPq_message",
  "messages_list": "S7_QPq_messages_list",
  "sidebar": "S7_QPq_sidebar",
  "sidebar_open": "S7_QPq_sidebar_open",
  "user_message": "S7_QPq_user_message",
});
